<template>
  <div id="applyFileUpload">


    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <!-- 
      :selectList="selectList" 
      :requestForm="requestForm"
     -->
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      :tableOption="tableOption"
      :batchOperBtn="batchOperBtn"
      :isDisabledMultiple="isDisabledMultiple"
      @handleSelectionChange="bachOper"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 单个处理异常弹窗 -->
    <ots-custom-dialog :dialog.sync="uploadDialog" :title="isShow ? '查看': '审核'" width="720px">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <p><span style="display: inline-block; width: 100px; margin-bottom: 16px;">批次名称：</span>{{dialogInfo.planName}}</p>
              <p><span style="display: inline-block; width: 100px;">教学点：</span>{{dialogInfo.stationName}}</p>
            </div>
            <div>
              <el-form-item label="报名附件：" width="100%">

                <!-- :on-remove="handleRemove" -->
                <el-upload
                  class="upload-demo"
                  action=""
                  :on-change="handleSuccess"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload" 
                  :http-request="uploadImg"
                  list-type="picture">
                  <!-- <el-button size="small" type="primary" v-if="!isShow">点击上传</el-button> -->
                  <!--  @click="openImg(file, file.url)" -->

                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="defaultUrl" alt=""  @click="openImg(file, file.url)" v-if="file.type == 'pdf'">
                    <img class="el-upload-list__item-thumbnail" :src="wordDefaultUrl" alt=""  @click="openImg(file, file.url)" v-else-if="file.type == 'doc' || file.type == 'docx'">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""  @click="openImg(file, file.url)" v-else>
                    
                    <span class="el-upload-list__item-actions">
                      <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                      <span class="el-upload-list__item-preview">
                        {{ file.name }}
                      </span>
                    </span>
                    <label class="el-upload-list__item-status-label">
                      <i class="el-icon-upload-success el-icon-check"></i>
                    </label>
                    <!-- <i class="el-icon-close" @click="handleRemove(file, fileList)" v-show="!isShow"></i> -->
                  </div>
                </el-upload>
              </el-form-item>
            </div>
            <div v-if="!isShow">
              <el-form-item label="不通过原因：">
                <el-input placeholder="请输入" v-model="auditRemark"></el-input>
              </el-form-item>
            </div>
            <div></div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round type="primary" @click="executeUpload(2)" v-if="!isShow">审核通过</el-button>
        <el-button round type="primary" @click="executeUpload(3)" v-if="!isShow">审核不通过</el-button>
        <el-button round @click="uploadDialog = false" plain>取消</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getPagePlan } from "@/http/modules/examSet/examBatch";
import { getStationFilesStationAPI, getStationFilesPlanAPI, uploadStationFilesAPI, exportAuditFilesAPI, exportAuditFilesInfoAPI, deleteStationFilesAPI, getAuditListAPI, saveAuditFilesAPI, cancelAuditFilesAPI } from "@/http/modules/custom";

export default {
  data() {
    return {
      batchOperBtn: [],
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      wordDefaultUrl: require("@/assets/img/WORDIcon.jpg"),
      fileList: [],
      tableOption: {
        multiple: false,
      },
      mainTopBtnList: [
        {
          title: '导出报名材料',
          fn: this.exportFileInfo
        },
        {
          title: "导出",
          fn: this.exportInfo
        }
      ],
      requestForm: {
        planId: "",
        stationId: "",
        auditStatus: "",
        page: 1,
        size: 10,
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
          isSearch: true,
        },
        {
          // title: this.isSetStateName,
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        { // auditStatus
          title: "审核状态",
          type: "select",
          requestKey: "auditStatus",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            // { id: "0", name: "未提交" },
            { id: "1", name: "等待审核" },
            { id: "2", name: "审核通过" },
            { id: "3", name: "审核不通过" },
          ],
        },
      ],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "启用状态",
          prop: "planName",
          formatter: (scope) => {
            return scope.row.canEdit == 1 ? "启用": "停用";
          }
        },
        {
          title: "教学点",
          prop: "stationName"
        },
        {
          title: "上传时间",
          prop: "createDate",
        },
        {
          title: "审核状态",
          prop: "auditStatusName",
        },
        {
          title: "审核时间",
          prop: "auditDate",
        },
        {
          title: "审核意见",
          prop: "auditRemark",
        },
        {
          title: "报名附件",
          type: "button",
          prop: "",
          formatter: () => "查看",
          click: this.showUploadFile,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "审核",
              formatter: (scope) => {
                return scope.row.auditStatusName != "等待审核";
              },
              click: (row) => {
                this.saveStationFiles(row, 1)
              },
            },
            {
              title: "撤销审核",
              formatter: (scope) => {
                return scope.row.auditStatusName == "等待审核";
              },
              click: (row) => {
                this.saveStationFiles(row, 0)
              },
            },
          ],
        },
      ],
      tableData: [],
      pagination: { total: 0 },
      uploadDialog: false,
      planList: [],
      isShow: false,
      stationFilesId: "",
      auditRemark: "",
      dialogInfo: {
        planName: "",
        stationName: "",
      },
      stationFilesIds: [],
    }
  },

  watch: {
    "requestForm.planId": function() {
      this.initStationData();
      this.getTableData();
    }
  },


  created() {
    // han0007
    // Qaz@2024
  },

  mounted() {
    this.initData();
    this.getTableData();
  },

  methods: {
    /*************************************
     * @param { 初始化数据 }
     ************************************/
    async initData() {
      const { data } = await getStationFilesPlanAPI();
      this.planList = data;
      this.selectList[0].data = [{id: "", name: "全部"}, ...data];
      // this.requestForm.planId = data[0].id;
    }, 

    async initStationData() {
      const { data: stationList} = await getStationFilesStationAPI({planId: this.requestForm.planId})
      let newStationList = [{ id: "", name: "全部" }, ...stationList];
      this.$set(this.selectList[1], "data", newStationList);
    },

    /*************************************
     * @param { 查询 }
     ************************************/
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    /*************************************
     * @param { 表格查询 }
     ************************************/
    async getTableData() {
      /* 
      planId: "",
        stationId: "",
        auditStatus: "",
       */
      // let params = {
      //   auditStatus: this.requestForm.auditStatus,
      //   // planId: this.requestForm.planId,
      //   stationId: this.requestForm.stationId,
      //   size: this.requestForm.size,
      //   page: this.requestForm.page
      // };

      let params = { ...this.requestForm };

      const { data, code } = await getAuditListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    /*************************************
     * @param { 材料上传 }
     ************************************/
    uploadStationFiles() {
      this.fileList = [];
      this.isShow = false;
      this.$nextTick(() => {
        this.uploadDialog = true;
      })
    },

    /*************************************
     * @param { 材料上传：本地删除 }
     ************************************/
    async handleRemove(file, fileList) {
      let params = {
        stationFilesId: this.stationFilesId,
        stationFilesDetailId: file.stationFilesDetailId
      }
      const { code } = await deleteStationFilesAPI(params);
      if (code) {
        this.$message.success("删除成功！");
      }
      this.fileList = fileList.filter(function(e){
        return e.uid != file.uid;
      });
    },
    
    /*************************************
     * @param { 材料上传：本地上传成功 }
     ************************************/
    handleSuccess(file, fileList) {
      fileList.map( e => {
        e.type = e.name.substring(e.name.lastIndexOf(".") + 1);
      })
      this.fileList = fileList;
    },

    /*************************************
     * @param { 材料上传：格式校验 }
     ************************************/
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png", "pdf"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < 2048 * 4;
      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式，且大小不能超过 2048 kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 2048 kb!`);
      }
      return isJPG && isLt30kb;
    },

    /*************************************
     * @param { 材料上传：执行 }
     ************************************/
    async uploadImg(data) {
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("planId", this.requestForm.planId);
      await uploadStationFilesAPI(formData);
    },

    /*************************************
     * @param { 材料上传：关闭弹窗 }
     ************************************/
    async executeUpload(auditStatus) {
      let params = {
        auditStatus,
        stationFilesId: this.stationFilesId,
        auditRemark: this.auditRemark
      }

      const { code } = await saveAuditFilesAPI(params);
      if (code) {
        this.$message.success("操作成功！");
      }

      this.getTableData();
      this.uploadDialog = false;
    },

    /*************************************
     * @param { 报名附件：查看 }
     ************************************/
    async showUploadFile(row) {
      this.dialogInfo = row;
      this.stationFilesId = row.stationFilesId;
      let fileData = [];
      row.detailList.map( e => {
        let type = e.fileName.substring(e.fileName.lastIndexOf(".") + 1);
        let item = { url: e.fileUrl, name: e.fileName, stationFilesDetailId: e.stationFilesDetailId, type };
        fileData.push(item);
      })
      this.fileList = fileData;
      this.$nextTick(() => {
        this.isShow = true;
        this.uploadDialog = true;
      })
    },

    /*************************************
     * @param { 报名附件：审核、撤销审核 }
     ************************************/
    async saveStationFiles(row, auditFlag) {
      this.auditRemark = row.auditRemark ? row.auditRemark: "";

      if (auditFlag === 1) {
        this.dialogInfo = row;
        this.stationFilesId = row.stationFilesId;
        let fileData = [];
        row.detailList.map( e => {
          let type = e.fileName.substring(e.fileName.lastIndexOf(".") + 1);
          let item = { url: e.fileUrl, name: e.fileName, stationFilesDetailId: e.stationFilesDetailId, type };
          fileData.push(item);
        })
        this.fileList = fileData;
        this.$nextTick(() => {
          this.isShow = false;
          this.uploadDialog = true;
        })
      } else {
        const { code } = await cancelAuditFilesAPI({stationFilesId: row.stationFilesId});
        if (code) {
          this.$message.success("撤销审核成功！");
          this.getTableData();
        }
      }
    },

    /*************************************
     * @param { 导出报名材料 }
     ************************************/
    async exportFileInfo() {
      let { planId, stationId, auditStatus } = this.requestForm;
      let params = {
        planId,
        stationId,
        auditStatus
      }
      const { code, data } = await exportAuditFilesAPI(params);
      if (code) {
        window.open(data);
      }
    },

    /*************************************
     * @param { 导出 }
     ************************************/
    async exportInfo() {
      let { planId, stationId, auditStatus } = this.requestForm;
      let params = {
        planId,
        stationId,
        auditStatus
      }
      const { code, data } = await exportAuditFilesInfoAPI(params);
      if (code) {
        window.open(data);
      }
    },

    openImg(file, url) {
      window.open(url);
    },

    isDisabledMultiple(row) {
      let { auditStatusName } = row;
      if (auditStatusName == "等待审核") {
        return true;
      }
      return false;
    },

    batchAudit() {
      if (this.stationFilesIds.length == 0) {
        this.$message.warning("请勾选审核信息！");
        return false;
      } else {
        
      }
    },

    bachOper(val) {
      let stationFilesIds = [];
      val.forEach((item) => {
        stationFilesIds.push(item.stationFilesId);
      });
      this.stationFilesIds = stationFilesIds;
    },

    changeSize(num) {
      this.requestForm.size = num;
      this.getTableData();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }
}
</script>

<style scoped lang="less">
.el-form-item {
  display: flex;
  align-items: center;
}
/deep/ .el-upload-list__item {
  min-width: 450px;
}
</style>